import { z } from "zod";

import { companyOnboardingEvent } from "./companyOnboardingEvent";
import { companyTaskDefinitionEvent } from "./companyTaskDefinitionEvent";
import { companyWorkLocationEvent } from "./companyWorkLocationEvent";
import { partnerOnboardingEvent } from "./partnerOnboardingEvent";
import { whitelabelTaskDefinitionEvent } from "./whitelabelTaskDefinitionEvent";
import { contractorEvent } from "./contractorEvent";
import { employeeCheckEvent } from "./employeeCheckEvent";
import { employeeEvent } from "./employeeEvent";
import { employeeTaxParameterEvent } from "./employeeTaxParameterEvent";
import { notificationEvent } from "./notificationEvent";
import { shiftEvent } from "./shiftEvent";
import { transactionEvent } from "./transactionEvent";
import { accrualPolicyEmployeeEvent } from "./accrualPolicyEmployeeEvent";

export const eventsUnion = z.discriminatedUnion("source", [
  employeeCheckEvent,
  employeeEvent,
  employeeTaxParameterEvent,
  contractorEvent,
  companyTaskDefinitionEvent,
  companyOnboardingEvent,
  whitelabelTaskDefinitionEvent,
  partnerOnboardingEvent,
  companyWorkLocationEvent,
  notificationEvent,
  shiftEvent,
  transactionEvent,
  accrualPolicyEmployeeEvent,
]);

export type EventsUnion = z.infer<typeof eventsUnion>;
